import { StylesConfig } from "react-select";

export interface OptionType<T = string> {
	value: T;
	label: string;
}

export const filtersConfig = (data: string, controlSize: "m" | "sm"): StylesConfig<OptionType> => ({
	control: (provided) => ({
		...provided,
		minHeight: "20px",
		height: controlSize == "sm" ? "25px" : undefined,
		fontSize: "12px",
		borderColor: "#d8d5d5",
		boxShadow: "none",
		"&:hover": {
			borderColor: "#d8d5d5",
		},
	}),
	input: (provided) => ({
		...provided,
		padding: "0px",
		margin: "1px",
	}),
	container: (provided) => ({
		...provided,
		flexGrow: 1,
	}),
	indicatorsContainer: (provided) => ({
		...provided,
		padding: "0px 2px",
		height: controlSize == "sm" ? "25px" : undefined,
	}),
	clearIndicator: (provided) => ({
		...provided,
		padding: "0px 2px",
	}),
	menu: (provided) => ({
		...provided,
		background: "white",
		border: "1px solid var(--itemBorder)",
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "200px",
	}),
	option: (provided, state) => ({
		...provided,
		fontSize: "12px",
		backgroundColor: state.isSelected ? "#EDEEF4" : "white",
		color: "black",
		"&:hover": {
			backgroundColor: "#EDEEF4",
		},
	}),
	noOptionsMessage: (provided) => ({
		...provided,
		fontSize: "12px",
	}),
	loadingMessage: (provided) => ({
		...provided,
		fontSize: "12px",
	}),
	dropdownIndicator: (provided) => ({
		...provided,
		padding: "4px",
	}),
	placeholder: (provided) => ({
		...provided,
		fontSize: "12px",
		color: "#afb2b8",
		whiteSpace: "nowrap",
	}),
});
